<ng-container *ngIf="!item.route?.endsWith('/notice/detail') && (!item.route?.endsWith('#') || !!item.hasChildren)">
  <mat-list-item>
    @if(isRouterItem(item))
    {
      <a [routerLink]="routerLinkFor(item)"

        class="hamburger-menu-link app-route"
        data-testid="side-nav-item"
        [attr.data-nav-item]="item.displayName"
        mat-list-item [activated]="item.isActive || false"
        [ngStyle]="{ 'margin-left': depth * 12 + 'px' }"
        (click)="onItemSelected($event, item); ">

        <ng-container *ngTemplateOutlet="menuItemText"></ng-container>
      </a>
    }
    @else
    {
      <!-- Use attr.href for anything else -->
      <a [attr.href]="item.isThisApp == false ? item.hasChildren ? null : item.hasExtension ? item.url : item.route : null"

      class="hamburger-menu-link"
      data-testid="side-nav-item"
      [attr.data-nav-item]="item.displayName"
      [ngClass]="{'app-route': itemHasAppRouteChildren(item)}"
      mat-list-item [activated]="item.isActive || false"
      [ngStyle]="{ 'margin-left': depth * 12 + 'px' }"
      (click)="onItemSelected($event, item); ">

      <ng-container *ngTemplateOutlet="menuItemText"></ng-container>

    </a>
    }
  </mat-list-item>

  @if(expanded)
  {
    @for (child of item.children; track child; let i = $index)
    {
      <app-side-menu-item [item]="child" [depth]="depth + 1" (nav)="nav.emit($event)"> </app-side-menu-item>
    }
  }

</ng-container>

<!-- Template used for the text of the item whether it's using routerLink or href -->
<ng-template #menuItemText>
  @if (item.iconName) {
    <mat-icon mat-list-icon>{{ item.iconName }}</mat-icon>
  }

  <span class="flex">
    {{ item.displayName }}

    @if(item.hasChildren)
    {
      <mat-icon [inline]="true" class="hamburger-menu-toggle-icon"  [@indicatorRotate]="expanded ? 'expanded' : 'collapsed'"> expand_more </mat-icon>
    }

    <mat-icon [inline]="true" *ngIf="item.isAtEndOfActivatedRoute">my_location</mat-icon>
  </span>
</ng-template>
